<template>
  <span>{{ canReadPricing ? formattedAmount : "" }}</span>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { usePricingPermission } from "@/core/composables";

interface IProps {
  amount: number;
  cultureName: string;
  currencyCode: string;
}

const props = defineProps<IProps>();
// Innovadis custom: hide totals when the user does not have pricing:read permission.
const { canReadPricing } = usePricingPermission();

const formattedAmount = computed(() =>
  new Intl.NumberFormat(props.cultureName, {
    currency: props.currencyCode,
    style: "currency",
  }).format(props.amount),
);
</script>
